import { Routes } from '@angular/router';
import { PublicLayoutComponent } from './components/layouts/public-layout/public-layout.component';
import { authGuard } from 'lib-base';
import { ConsultaTramitesComponent } from './pages/public/consulta-tramites/consulta-tramites.component';
import { VerInformacionTramiteComponent } from './pages/public/ver-informacion-tramite/ver-informacion-tramite.component';
import { ActivarUsuarioComponent } from './pages/public/activar-usuario/activar-usuario.component';
import { RestablecerPasswordComponent } from './pages/public/restablecer-password/restablecer-password.component';
import { EstadoTramitesComponent } from './pages/tramitante/estado-tramites/estado-tramites.component';
import { EstadoTramitesPubComponent } from "./pages/public/estado-tramites-pub/estado-tramites-pub.component";
import { MisFacturasComponent } from './pages/tramitante/mis-facturas/mis-facturas.component';
import { MisPagosComponent } from './pages/tramitante/mis-pagos/mis-pagos.component';
import { ConsultaPagoComponent } from "./pages/tramitante/pagos/consulta-pago/consulta-pago.component";
import { hasFirmaGuard } from "./guards/has-firma.guard";
import {
  DetalleRadicadoComponent
} from "./pages/tramitante/procesar-tramite/detalle-radicado/detalle-radicado.component";
import { ComprobantePagoComponent } from "./pages/tramitante/pagos/comprobante-pago/comprobante-pago.component";
import { PqrsdfLandingComponent } from "./pages/public/pqrsdf/pqrsdf-landing/pqrsdf-landing.component";
import { ProfileFormComponent } from "./pages/tramitante/profile-form/profile-form.component";
import { FormularioPqrsdfComponent } from "./pages/public/pqrsdf/formulario-pqrsdf/formulario-pqrsdf.component";
import { PoliticaDatosComponent } from "./pages/public/politica-datos/politica-datos.component";
import { EstadoPqrsdComponent } from "./pages/public/pqrsdf/estado-pqrsd/estado-pqrsd.component";
import { SedeElectronicaComponent } from "./pages/public/sede-electronica/sede-electronica.component";
import { SedeElectronicaHomeComponent} from "./pages/public/sede-electronica/sede-electronica-home/sede-electronica-home.component";
import { SedeElectronicaPqrsdfComponent} from "./pages/public/sede-electronica/sede-electronica-pqrsdf/sede-electronica-pqrsdf.component";
import { SedeElectronicaTramitesComponent} from "./pages/public/sede-electronica/sede-electronica-tramites/sede-electronica-tramites.component";
import { SolicitarFirmaElectronicaComponent } from './pages/firma-electronica/solicitar-firma-electronica.component';
import { RenovarFirmaElectronicaComponent } from './pages/firma-electronica/renovar-firma-electronica.component';
import { RevocarFirmaElectronicaComponent } from './pages/firma-electronica/revocar-firma-electronica.component';
import { CustomCreateTramitesComponent } from "../../../sisben/src/app/components/custom-create-tramites/custom-create-tramites.component";
import { customComponentsResolver } from "../../../sisben/src/app/resolvers/custom-components.resolver";
import { AppNotFoundComponent } from "../../../lib-base/src/lib/components";
import { CreateTramiteComponent } from './pages/tramitante/create-tramite/create-tramite.component';
import { ComprobantePagoPseComponent } from "./pages/tramitante/pagos/comprobante-pago-pse/comprobante-pago-pse.component";

export const routes_sede_electronica = [
  {
    path: 'sede-electronica', component: SedeElectronicaComponent,
    children: [
      { path: 'inicio', component: SedeElectronicaHomeComponent },
      { path: 'pqrsd', component: SedeElectronicaPqrsdfComponent },
      { path: 'consulta', component: SedeElectronicaTramitesComponent },
      { path: 'consulta/:text', component: SedeElectronicaTramitesComponent },
      { path: 'informacion/:tipoTramiteId/:dependenciaId', component: VerInformacionTramiteComponent },
      { path: 'estado-tramite', component: EstadoTramitesPubComponent },
      { path: "estado-tramite/:radicado", component: EstadoTramitesPubComponent },
      { title: 'Formulario PQRSDF', path: 'formulario-pqrsd/:tipo', component: FormularioPqrsdfComponent },
      { path: "estado-pqrsdf", component: EstadoPqrsdComponent },
      { path: "estado-pqrsdf/:radicado", component: EstadoPqrsdComponent },
      { pathMatch: 'full', path: '', redirectTo: 'inicio' },
    ]
  }
] as Routes;

export const routes_public = [
  {
    path: 'public', component: PublicLayoutComponent,
    children: [
      { path: 'consulta', component: ConsultaTramitesComponent },
      { path: 'consulta/:text', component: ConsultaTramitesComponent },
      { path: 'informacion/:tipoTramiteId/:dependenciaId', component: VerInformacionTramiteComponent },
      { path: "estado-tramite", component: EstadoTramitesPubComponent },
      { path: "estado-tramite/:radicado", component: EstadoTramitesPubComponent },
      { path: 'activar-usuario/:codigo', component: ActivarUsuarioComponent },
      { path: 'restablecer-password/:codigo', component: RestablecerPasswordComponent },
      { path: 'politica-datos', component: PoliticaDatosComponent },
      { title: 'Formulario PQRSDF', path: 'formulario-pqrsd/:tipo', component: FormularioPqrsdfComponent },
      { path: "estado-pqrsdf", component: EstadoPqrsdComponent },
      { path: "estado-pqrsdf/:radicado", component: EstadoPqrsdComponent },
      { redirectTo: 'consulta', pathMatch: 'full', path: '' },
    ]
  },
] as Routes;

export const routes_tramites = [
  {
    path: 'tramites', component: PublicLayoutComponent,
    canActivate: [authGuard('public/consulta')],
    canActivateChild: [authGuard('public/consulta')],
    children: [
      { path: "consulta-pagos", component: ConsultaPagoComponent, canActivate: [hasFirmaGuard] },
      { path: "comprobante-pago", component: ComprobantePagoComponent },
      { path: "comprobante-pago-pse", component: ComprobantePagoPseComponent },
      { path: "detalle-radicado", component: DetalleRadicadoComponent, canActivate: [hasFirmaGuard] },
      { path: "estado-tramite", component: EstadoTramitesComponent },
      { path: 'mis-facturas', component: MisFacturasComponent },
      { path: 'mis-pagos', component: MisPagosComponent },
      { path: 'perfil', component: ProfileFormComponent },
      /* { path: "landing", component: LandingComponent },*/
      { path: "**", component: ConsultaTramitesComponent }
    ]
  },
]

export const routes_firma_electronica = [
  {
    path: 'firma-electronica', component: PublicLayoutComponent,
    canActivate: [authGuard('public/consulta')],
    canActivateChild: [authGuard('public/consulta')],
    children: [
      { path: "solicitar", component: SolicitarFirmaElectronicaComponent },
      { path: "renovar", component: RenovarFirmaElectronicaComponent },
      { path: "revocar", component: RevocarFirmaElectronicaComponent },
      { path: "**", component: ConsultaTramitesComponent }
    ]
  },
]

//Este siempre va de ultimo...
export const routes_other = [
  { path: 'pqrsdf', component: PqrsdfLandingComponent },
  { path: "not-found", component: AppNotFoundComponent },
  { path: '', redirectTo: 'public/consulta', pathMatch: 'full' },
  { path: "**", component: AppNotFoundComponent }
] as Routes;


// Insertar ruta para crear tramites, esto se hace despues para que otros proyectos puedan definir sus propias rutas
(routes_tramites[0].children as any[]).unshift(
  { path: "crear-tramite/:dependenciaId/:tramiteId", component: CreateTramiteComponent },
  { path: "crear-tramite/:dependenciaId/:tramiteId/:empresaId", component: CreateTramiteComponent },
);


export const routes: Routes = [
  ...routes_sede_electronica,
  ...routes_public,
  ...routes_tramites,
  ...routes_firma_electronica,
  ...routes_other,
];
